export function getCoverScale(image, canvas) {
  const scaleX = canvas.width / image.width;
  const scaleY = canvas.height / image.height;

  return Math.max(scaleX, scaleY);
}